export const setCellData = (Table, Index, Column, Value) => {

    return function (dispatch) {

        if(Table.data){
            Table.data[Index][Column] = Value;

            dispatch({
                type: 'CELL_DATA',
                payload: {
                    data: {tableData: Table}
                }
            })
        }
        else if(Table.subData){
            Table.subData[Index][Column] = Value;

            dispatch({
                type: 'CELL_SUBDATA',
                payload: {
                    data: {tableData: Table}
                }
            })
        }


    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/setCellData.js